import React, { useMemo, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { CTitle } from '../../components/Widget';
import { useUpdateComponentState } from '../../../hooks';
import Quiz from '../../components/Quiz';
import SenderVerification from '../../components/SenderVerification';
import DoDontCards from '../../components/DoDontCards';
import doImg from '../../../../../../assets/sme/uats/do_circle.png';
import dontImg from '../../../../../../assets/sme/uats/dont_circle.png';
import FourPartIllustration from '../../../../../../assets/sme/uats/FourPartIllustration.png';
import quizBg from '../../../../../../assets/sme/uats/quiz_bg.png';

interface ISection3Props {
  settings: any;
}

const Section3: React.FunctionComponent<ISection3Props> = ({ settings }) => {
  const ID = '4';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[3],
    [settings?.paragraphs]
  );
  const updateComponentState = useUpdateComponentState();

  const { quiz } = paragraphsSettings ?? {};

  const doColumn = useMemo(
    () => ({
      title: paragraphsSettings?.doTitle,
      image: doImg,
      items: paragraphsSettings?.doList ?? [],
    }),
    [paragraphsSettings?.doTitle, paragraphsSettings?.doList]
  );

  const dontColumn = useMemo(
    () => ({
      title: paragraphsSettings?.dontTitle,
      image: dontImg,
      items: paragraphsSettings?.dontList ?? [],
    }),
    [paragraphsSettings?.dontTitle, paragraphsSettings?.dontList]
  );

  const fourStepItems = useMemo(
    () =>
      (paragraphsSettings?.fourSteps ?? []).map(
        (step: { no: string; badge: string; text: string }) => ({
          step: step.no,
          title: step.badge,
          description: step.text,
        })
      ),
    [paragraphsSettings?.fourSteps]
  );

  const handleStepComplete = useCallback(() => {
    updateComponentState(p_course, p_topic, ID, 'sme-uats-section3-1');
  }, [updateComponentState, p_course, p_topic]);

  const handleQuizComplete = useCallback(() => {
    updateComponentState(p_course, p_topic, ID, 'sme-uats-section3-question');
  }, [updateComponentState, p_course, p_topic]);

  return (
    <div className="topic-section-3">
      <CTitle title={paragraphsSettings?.title} />

      <DoDontCards doColumn={doColumn} dontColumn={dontColumn} />
      <div className="uats-section-container">
        <CTitle title={paragraphsSettings?.fourStepTitle} />
        <SenderVerification
          steps={fourStepItems}
          imgBg={FourPartIllustration}
          id="sme-uats-section3-1"
          onComplete={handleStepComplete}
        />
      </div>
      <div id="sme-uats-section3-question" className="topic-quiz">
        <Quiz
          title={paragraphsSettings?.questionTitle ?? ''}
          description={quiz?.description ?? ''}
          question={quiz?.question ?? ''}
          options={quiz?.options ?? []}
          quizImg={quizBg}
          onCompleted={handleQuizComplete}
        />
      </div>
    </div>
  );
};

export default React.memo(Section3);
